module Client.AdminShared

type ClickAction = 
    | Edit
    | Delete

type LoadState<'a, 'b> =
    | Loading of 'a
    | Loaded of 'b

type SuccessMessageChange =
    | Unchanged
    | Show of message: string
    | Hide

open System
open Shared.Domain
let locationContainsSpaces location =
    let id = Slug.get location.Id
    id.Contains " "